import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";

export const TagsHeader = ({ column }: HeaderContext<any, unknown>) => {
  return (
    <DataTableColumnHeader
      column={column}
      title="Tags"
      style={{ padding: "5px" }}
    />
  );
};
